// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-goals-goal[data-v-3cbf616d]{position:relative;background-color:#e2e2e2;padding:10px 0;margin-bottom:30px}.event-goals-goal__button[data-v-3cbf616d]{cursor:pointer;color:#828282;font-size:24px;min-width:30px;display:inline-block}.event-goals-goal__button.delete-button[data-v-3cbf616d]{color:#E6493B;font-size:25px}\n", ""]);
// Exports
module.exports = exports;
